"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M21.5 4C22.878 4 24 5.122 24 6.5v11c0 1.378-1.122 2.5-2.5 2.5h-19A2.503 2.503 0 0 1 0 17.5v-11C0 5.122 1.122 4 2.5 4h19Zm1.5 7H1v6.5c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5V11ZM9.5 16a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Zm0-2a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6ZM23 8H1v2h22V8Zm-1.5-3h-19C1.673 5 1 5.673 1 6.5V7h22v-.5c0-.827-.673-1.5-1.5-1.5Zm-2 12h-1c-.827 0-1.5-.673-1.5-1.5v-1c0-.827.673-1.5 1.5-1.5h1c.827 0 1.5.673 1.5 1.5v1c0 .827-.673 1.5-1.5 1.5Zm-1-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};